module.exports = __webpack_public_path__ + "img/zs7.2010fa7b.png";